/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  GetTaskSummaryParams,
  GetTasksRequest,
  PageTaskDtoObject,
  TasksSummaryDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MyTasksController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags my-tasks-controller
   * @name GetMyTasks
   * @request POST:/api/v1/my-tasks
   */
  getMyTasks = (data: GetTasksRequest, params: RequestParams = {}) =>
    this.http.request<PageTaskDtoObject, any>({
      path: `/v1/my-tasks`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMyTasksPath = '/v1/my-tasks'
  static getMyTasksMethod = 'POST'
  /**
   * No description
   *
   * @tags my-tasks-controller
   * @name GetTaskSummary
   * @request POST:/api/v1/my-tasks/summary
   */
  getTaskSummary = (query: GetTaskSummaryParams, params: RequestParams = {}) =>
    this.http.request<TasksSummaryDto, any>({
      path: `/v1/my-tasks/summary`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static getTaskSummaryPath = '/v1/my-tasks/summary'
  static getTaskSummaryMethod = 'POST'
}
